import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import type { Settings, CustomArrowProps } from 'react-slick';
import Slider from 'react-slick';
import { CarouselItem } from '~/Partials/CarouselItem/CarouselItem';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './CarouselBlock.module.css';
import type { CarouselBlockViewModel } from './CarouselBlockViewModel.csharp';

const PrevArrow: React.FC<React.PropsWithChildren<CustomArrowProps>> = ({ onClick }) => (
    <div className={classNames(styles.Arrow, styles.PrevArrow)} role="none" onClick={onClick}>
        <SvgIcon iconName="chevron-right" />
    </div>
);

const NextArrow: React.FC<React.PropsWithChildren<CustomArrowProps>> = ({ onClick }) => (
    <div className={classNames(styles.Arrow, styles.NextArrow)} role="none" onClick={onClick}>
        <SvgIcon iconName="chevron-right" />
    </div>
);

interface CarouselBlockState {
    activeItemIndex: number;
}

export class CarouselBlock extends React.Component<CarouselBlockViewModel, CarouselBlockState> {
    private readonly sliderSettings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        lazyLoad: 'ondemand',
        afterChange: current => this.updateActiveItemIndex(current),
    } as Settings;

    constructor(props: CarouselBlockViewModel) {
        super(props);

        this.state = {
            activeItemIndex: 0,
        };
    }

    private updateActiveItemIndex(current: number): void {
        return this.setState({ activeItemIndex: current });
    }

    render() {
        const { items } = this.props;
        const { activeItemIndex } = this.state;

        return (
            <section className={styles.CarouselBlock}>
                <Slider {...this.sliderSettings}>
                    {items.map((item, index) => (
                        <CarouselItem key={uniqueId('CarouselItem__')} {...item} isActive={index === activeItemIndex} />
                    ))}
                </Slider>
            </section>
        );
    }
}
